<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{
              $t(`problemCategory.warehouseProblem`, {
                expr: modelValue !== undefined ? "Edit" : "Add",
              })
            }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`confirmModal.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="text-start m-2 custom-input col-12">
              <div class="row">
                <div class="col-12 mb-3 whitebg-input">
                  <label class="form-label bold-12 text-gray">{{
                    $t("problemCategory.name")
                  }}</label>
                  <input class="form-control" v-model="addRow.name" />
                </div>
                <div class="col-12 mb-3 whitebg-input">
                  <label class="form-label bold-12 text-gray">{{
                    $t("problemCategory.description")
                  }}</label>
                  <textarea class="form-control" v-model="addRow.description" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="modelValue !== undefined"
            type="button"
            class="btn btn-primary"
            v-on:click="save"
            :class="{ 'loading-spin': loadAddBtn }"
            :disabled="loadAddBtn"
          >
            {{ $t("finance.save") }}
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary"
            v-on:click="add"
            :class="{ 'loading-spin': loadAddBtn }"
            :disabled="loadAddBtn"
          >
            {{ $t("customRowModal.addRow") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";

const bootstrap = require("bootstrap");

export default {
  name: "ProblemCategoryModal",
  props: {
    modelValue: Object,
  },
  data() {
    return {
      myModal: undefined,
      loadAddBtn: false,
      addRow: {
        name: "",
        description: "",
      },
    };
  },
  watch: {
    modelValue() {
      if (this.modelValue !== undefined) {
        this.addRow.name = this.modelValue.name;
        this.addRow.description = this.modelValue.description;
      } else {
        this.addRow.name = "";
        this.addRow.description = "";
      }
    },
  },
  emits: ["update:modelValue", "newItem"],
  methods: {
    showModal() {
      this.myModal = new bootstrap.Modal(this.$refs.modal, {
        backdrop: "static",
      });
      this.myModal.show();
    },
    save() {
      this.loadAddBtn = true;
      http
        .fetch(
          "/orders/problem-categories/" + this.modelValue.id,
          this.addRow,
          true,
          "PUT"
        )
        .then((data) => {
          this.$emit("update:modelValue", data.data);
          this.myModal.hide();
          this.loadAddBtn = false;
        })
        .catch(() => {
          this.loadAddBtn = false;
        });
    },
    add() {
      this.loadAddBtn = true;
      http
        .fetch("/orders/problem-categories", this.addRow, true)
        .then((data) => {
          this.$emit("newItem", data);
          this.myModal.hide();
          this.loadAddBtn = false;
          this.addRow.name = "";
          this.addRow.description = "";
        })
        .catch(() => {
          this.loadAddBtn = false;
        });
    },
  },
};
</script>
